module.exports = require("./ar-AE.js");